import type { Step } from '../../core/Types';
import { LeaseStepId } from '../../core/LeaseEnums';
import ManagerLeaseScene from './scenes/ManagerLeaseScene';

export const leaseSteps: Step[] = [
  {
    id: LeaseStepId.MANAGER_LEASE,
    title: 'Create lease',
    Scene: ManagerLeaseScene,
  },
];
